import React from "react";

const SaudiRiyalSymbol = ({ width = 16, height = 16, color = "#475467" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: "4px" }}
    >
      <path
        d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
        stroke={color}
      />
      <path
        d="M5.5 11V5H7.5C8.88071 5 10 6.11929 10 7.5V8.5C10 9.88071 8.88071 11 7.5 11H5.5Z"
        stroke={color}
        strokeWidth="0.8"
        fill="none"
      />
      <path
        d="M7 8.5H10"
        stroke={color}
        strokeWidth="0.8"
      />
    </svg>
  );
};

export default SaudiRiyalSymbol;